import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError, } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';
var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
var httpOptions;
if (isIEOrEdge) {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
    })
  };
} else {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('Ebom_accessToken'),
       'x-api-key':localStorage.getItem('Filename')
    })
  };
}
@Injectable({
  providedIn: 'root'
})
export class RecordCountsFromDataSourcesService {
  gridData = '/getRecordCounts/{proxy+}'

  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) { }


  //grid data
  getGridData(gridData): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let gridParams = new HttpParams().set('errStatCd', gridData.errStatCd)
    //   .append('dataSrcId', gridData.dataSrcId)
    //   .append('stdName', gridData.stdName)
    //   .append('seqNbr', gridData.seqNbr)
    //   .append('reasons', gridData.reasons)
    //   .append('strtDt', gridData.strtDt)
    //   .append('endDt', gridData.endDt)
    let API_URL =this.environment.QualandExcpgridapi1Url + this.gridData + '?errStatCd='+gridData.errStatCd
    + '&dataSrcId='+gridData.dataSrcId + '&stdName='+gridData.stdName + '&seqNbr='+gridData.seqNbr
    + '&reasons='+gridData.reasons + '&strtDt='+gridData.strtDt + '&endDt='+gridData.endDt+ '&option=' + gridData.option+'&screenNo=NBPC_7007'+'&fileName=' +fileName
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }


  statuscheck(body): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
 let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.QualandExcpgridapiUrl + '/editIexceptionReport/{proxy+}';
    return this.http.post(API_URL, body,httpOptions)
      .pipe(
        catchError(this.error)
      )
  }

  srcsyscheck(): Observable<any> {
    let API_URL = this.environment.QualandExcpgridapi1Url+ '/getSrcSysQual/{proxy+}'+'?screenNo=NBPC_7007'+'&fileName=' +fileName;
    return this.http.get(API_URL,httpOptions)
      .pipe(
        catchError(this.error)
      )
  }
  // Handle Errors 
  error(error: HttpErrorResponse) {
    let errorMessage:any = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = error.status;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
